import Blue from "~/core";

new Blue({
	name: 'Tag Filters Accordion',
	selector: ".tag-filters",
	setup(container) {
		const trigger = container.querySelector(".tag-filters__heading");
		const content = container.querySelector(".tag-filters__tags");
		const breakpoint = 768;
		let currentWindowWidth = window.innerWidth;

		// init accordion via $toggle
		const config = {
			container,
			trigger,
			content
		}
		let t = new this.$toggle(config);

		// if window resize passes md breakpoint in either direction, close accordion
		this.$addEvents(window, "resize", () => {
			let newWindowWidth = window.innerWidth;
			if (currentWindowWidth <= breakpoint && newWindowWidth > breakpoint ||
				currentWindowWidth > breakpoint && newWindowWidth <= breakpoint)
				{t.close();}
			currentWindowWidth = newWindowWidth;
		});
	}
});

new Blue({
	name: 'Tag Filters Click Effect/Style',
	selector: ".tag-filters",
	setup(container) {
		const tags = [...container.querySelectorAll(".tag-filters__tag")];
		
		if (!container.closest(".locations-listing")) {
			// toggle selected class when tag is clicked
			tags.forEach(tag => {
				this.$addEvents(tag, "click.prevent", () => {tag.classList.toggle("selected")});
			});
		}
	}
});